interface ExpandCollapseSectionProps {
  onExpand: () => void;
  onCollapse: () => void;
}

const Button = ({ text, onClick }: { text: string; onClick: () => void }) => {
  return (
    <button
      type="button"
      className="hover:underline text-xs px-2 hover:text-pink-600 text-pink-500"
      onClick={onClick}
    >
      {text}
    </button>
  );
};

export const ExpandCollapseSection = ({
  onExpand,
  onCollapse,
}: ExpandCollapseSectionProps) => {
  return (
    <div className="inline-flex items-center text-pink-500">
      <Button onClick={onExpand} text="Expand All" />
      {' / '}
      <Button onClick={onCollapse} text="Collapse All" />
    </div>
  );
};
